module.exports = __webpack_public_path__ + "media/images/portal-77b8b2ce44bf26633dc362e5831fad07.png";